import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { modalClose, modalOpen } from '../../../../layout/redux/layoutActions'
import { Button, IcoAdd, IcoPaste, IcoUpload, Input, InputFile, Modal, Select, validacaoForm, verificaValidacao } from '../../../../components'
import { history, idiomaCustom, numberAleatori } from '../../../../helpers'
import { criarEstabelecimento, editarEstabelecimento, putListMeuProjetoTab, setListMeuProjetoTab, setMeusProjetosLoad } from '../../redux/meusProjetosActions'
import { GruposEstabelecimentos } from './grupos'
import { PopoverCentralAjuda } from '../../../../components/popovercentralajuda/popovercentralajuda'
import { useRef } from 'react';

import { buscarSugestoesEnderecos, clearSugestoesEnderecos, buscarEnderecoDetalhado } from '../../redux/meusProjetosActions';
import './add.scss'; 


const formInit = { 
  nomeEstabelecimento: '', 
  nomeEmpresa: {}, 
  grupoEstabelecimento: {}, 
  ruaAvenidaRodovia: '', 
  numero: '', // Certifique-se de que este campo é uma string ou valor explícito
  bairro: '', 
  cidade: '', 
  estado: '', 
  cep: '', 
  pais: '', 
  urlTripAdvisorEstabelecimento: '', 
  urlBookingEstabelecimento: '',
  complemento: '',
  coordenadas: '',
}

export default ({data}) => {
  console.log('Valor de infomodal:', data);
  const dispatch = useDispatch()
  const { listas, sistema, statusModal } = useSelector(state => state.layoutState)
  const { load, meuProjeto } = useSelector(state => state.meusProjetosState)
  const nls = require(`../../nls/${sistema.idioma}.json`)
  const [erro, setErro] = useState({})  

  //const [form, setForm] = useState({})
  const [form, setForm] = useState(formInit);

  const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

  const nlsContexto = require(`../../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [124];
  const idarray1 = [123];
  const idarray2 = [125];
  const idarray3 = [127];

  const [sessionToken] = useState(() => crypto.randomUUID()); // Gera um token único para a sessão

  const lastExecution = useRef(0); // Armazena o timestamp da última execução (Throttle)

  // Obter as sugestões do estado global
  const sugestoes = useSelector((state) => state.sugestoesEnderecosState.sugestoes);

  
  useEffect(()=> {
    if (statusModal === 'criarEstabelecimentosMeuProjeto') {
      let infoInit = formInit
      const selectEmpresa = meuProjeto.empresas?.find(e=> e.nomeEmpresa === data?.nomeEmpresa)
      const selectgrupo = meuProjeto.gruposEstabelecimentos?.find(e=> e.nomeGrupoEstabelecimento === data?.grupoEstabelecimento)
  
      if (data?.idEstabelecimento) {
        infoInit = {
          ...formInit,
          ...data,        
          nomeEstabelecimento: 
            typeof data?.nomeEstabelecimento === 'string'
              ? data.nomeEstabelecimento
              : (typeof data?.nomeEstabelecimento?.props?.children?.[0] === 'string'
                  ? data.nomeEstabelecimento.props.children[0]
                  : ''),        
                
          nomeEmpresa: data?.nomeEmpresa?selectEmpresa:{}, 
          grupoEstabelecimento: data?.grupoEstabelecimento?selectgrupo:{}, 
          pais: data?.país?data?.país:'', 
          urlTripAdvisorEstabelecimento: data?.urlTripAdvisorEstabelecimento?data?.urlTripAdvisorEstabelecimento:'', 
          urlBookingEstabelecimento: data?.urlBookingEstabelecimento ? data?.urlBookingEstabelecimento : '',
        }
        
      }
  
      setForm(infoInit) 
        
      setErro({}); // Limpa o estado de erro ao abrir o modal
    }
  }, [data, statusModal])
  
  const formRequired = {
    nomeEstabelecimento: '',
    nomeEmpresa: 'select',
    grupoEstabelecimento: 'select',
    ruaAvenidaRodovia: '',
    numero: '',
    cidade: '',
    estado: '',
    cep: '',
    pais: '',
  }

  const OLDhandleInputChange = (e) => {
    const query = e.target.value;

    // Atualiza apenas o campo ruaAvenidaRodovia dentro do estado form
    setForm((prevForm) => ({
      ...prevForm, // Mantém os outros campos do formulário
      ruaAvenidaRodovia: query, // Atualiza o campo específico
    }));

    if (query.length > 2) {
      // Busca sugestões com base no texto digitado
      //console.log("SISTEMA.IDIOMA", sistema.idioma)
      dispatch(buscarSugestoesEnderecos(query, sessionToken));
    } else {
      // Limpa as sugestões caso o texto seja curto
      dispatch(clearSugestoesEnderecos());
    }
  };

  // Seleciona uma sugestão e preenche o campo
  // Seleciona uma sugestão e preenche o campo
const handleSugestaoClick = (descricao, placeId) => {
  

  // Limpa as sugestões ao selecionar
  dispatch(clearSugestoesEnderecos());

  // Chama a API para buscar os detalhes do endereço
  buscarEnderecoDetalhado(placeId)
    .then((data) => {

      // Limpa os campos que vão receber os dados detalhados
      setForm((prevForm) => ({
        ...prevForm,
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        pais: '',
        coordenadas: '',
      }));

      // Extraia apenas o nome da rua/avenida da descrição completa
      const somenteEndereco = data.rua || descricao.split(',')[0];


      // Atualiza o formulário com os valores retornados
      setForm((prevForm) => ({
        ...prevForm,
        ruaAvenidaRodovia: somenteEndereco,
        numero: data.numero || prevForm.numero,
        complemento: data.complemento || prevForm.complemento,
        bairro: data.bairro || prevForm.bairro,
        cidade: data.cidade || prevForm.cidade,
        estado: data.estado || prevForm.estado,
        cep: data.cep || prevForm.cep,
        pais: data.pais || prevForm.pais,
        coordenadas: data.latLon || prevForm.coordenadas,
      }));
    })
    .catch((error) => {
      console.error('Erro ao buscar detalhes do endereço:', error);
    });
};


  //console.log("HANDLECHANGE-E",e)
    //console.log("HANDLECHANGE-V",v)

  const handleChange = (e, v) => {

    //console.log("HANDLECHANGE-E",e)
    //console.log("HANDLECHANGE-V",v)
    setForm({...form, [e.name]: e.value})

    //ESTA PARTE ESTÁ ERRADA, CHECA SE CAMPO ESTÁ VÁZIO E MOSTRA OBRIGATÓRIO. DEVE APENAS MOSTRAR
    //OBRIGATÓRIO QUANDO O USUÁRIO CLICA E SALVAR FORMULÁRIO E O CAMPO ESTÁ VÁZIO
    //if (v?.name) {
    //  verifyErro(v)
    //}

    if (e.name === 'ruaAvenidaRodovia') {
      if (e.value.length > 2) {        
        // Dispara a ação para buscar sugestões
        const empresa = form?.nomeEmpresa?.nomeEmpresa || '';
        dispatch(buscarSugestoesEnderecos(e.value, sessionToken, sistema.idioma, empresa));
      } else {
        // Limpa as sugestões caso o texto seja curto
        dispatch(clearSugestoesEnderecos());
      }
    } 

  }
   

  const verifyErro = (e) => {
    setErro({...erro, [e.name]: e.message})
  } 

  const handleChangeFile = e => {
    setForm({...form, [e.name]: e.files})
  } 

  const handlerCriar = e => {
    delete e.actions
    delete e.checkboxCustom

//console.log("IDDOESTAB", data?.idEstabelecimento)

    const valid = validacaoForm({formValues: e, formRequired})
    setErro(valid)
    const verify = verificaValidacao(valid)


    if (verify.value) {     
      if (data?.idEstabelecimento) {
       
        dispatch(editarEstabelecimento({
          ...e,
          empresaId: e.nomeEmpresa?.empresaId,
          urlTripAdvisorEstabelecimento: e.urlTripAdvisorEstabelecimento || '',
          urlBookingEstabelecimento: e.urlBookingEstabelecimento || '',
          projetoId: meuProjeto.projeto.idProjeto,
          nlsPopup
        }));
        //dispatch(editarEstabelecimento({...e, projetoId: meuProjeto.projeto.idProjeto, nlsPopup}))    
      } else {
        dispatch(criarEstabelecimento({...e, projetoId: meuProjeto.projeto.idProjeto, nlsPopup}))
      }
    }
  }  

  const handleCloseModal = e => {
    setForm(formInit)
    setErro({}); 
    dispatch(modalClose()) 
  }  

  const handleColar = e => {
    navigator.clipboard.readText().then((clipText) => {
      setForm({...form, [e]: clipText})
    });
  }  

  const handleAddForm = e => {
    dispatch(setMeusProjetosLoad({name: 'estabelecimentosAddEdit', value: {...load.estabelecimentosAddEdit, add: !load.estabelecimentosAddEdit?.add}}))
  }  
  
 


  return (
    <Modal
    title={
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {!data?.idEstabelecimento ? (
          <>
            {nls.configurar?.addEstabelecimentoTitle}
            <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
          </>
        ) : (
          <>
            {nls.configurar?.editEstabelecimentoTitle}
            <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray3} />
          </>
        )}
      </div>
    }     
      size='medium'
      open={statusModal === 'criarEstabelecimentosMeuProjeto' ? true : false}
      close={() => dispatch(modalClose())}
      closeText={nls.criarProjeto?.btnFechar}
      actions={<>
        {data?.id? <Button
          color='default'
          onClick={()=> handleCloseModal()}
        >{nls.configurar?.btnCancelar}</Button>
        :null}
        <Button
          color='primary'
          onClick={()=> handlerCriar(form)}
        >{nls.configurar?.btnFinalizarSalvar}</Button>
      </>}
    >
      <div className='modal-meuProjeto-estabelecimentos-add'>
        <h5>{nls.configurar?.subTitleDetalhes}</h5>
        <div className='colflex col2'>
          <Input
            name='nomeEstabelecimento'
            label={nls.configurar?.formNome}
            value={form?.nomeEstabelecimento}
            placeholder={nls.configurar?.formNomePHEstabelecimento}
            action={(e, v) => handleChange(e, v)}
            required={{
              erro,
              pattern: formRequired.nomeEstabelecimento,
              message: nls.mensagem.obrigatorio
            }}
          />
          <Select
            name='nomeEmpresa'
            label={nls.configurar?.formEmpresa}
            options={meuProjeto.empresas}
            selected={form?.nomeEmpresa?form?.nomeEmpresa:{}}
            action={(e, v) => handleChange(e, v)}
            actionClose={(e, v) => verifyErro(v)}
            disabled={(data?.idEstabelecimento) ? true : false}
            textCustom={nls.select}
            optionLabel='nomeEmpresa'
            optionValue='empresaId'
            required={{
              erro,
              pattern: formRequired.nomeEmpresa,
              message: nls.mensagem.obrigatorio
            }}
          />
        </div>
        <div className='colflex justify'>
          <div className='colflex-100'>
            <Select
              name='grupoEstabelecimento'
              label={
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  {nls.configurar?.formGrupo}
                  <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray1} />
                </div>
              }              
              options={meuProjeto.gruposEstabelecimentos}
              selected={form?.grupoEstabelecimento?form?.grupoEstabelecimento:{}}
              action={(e, v) => handleChange(e, v)}
              actionClose={(e, v) => verifyErro(v)}
              textCustom={nls.select}
              optionLabel='nomeGrupoEstabelecimento'
              optionValue='idGrupoEstabelecimento'
              required={{
                erro,
                pattern: formRequired.grupoEstabelecimento,
                message: nls.mensagem.obrigatorio
              }}
            />
          </div>
          <div>
            <GruposEstabelecimentos
              show={load?.estabelecimentosAddEdit?.add}
              id={'add'}
              actionOpen={
                <Button
                  color='default circle'
                  onClick={()=> handleAddForm()}
                ><IcoAdd /></Button>
              }
            />
          </div>
        </div>
        <h5>{nls.configurar?.subTitleEndereco}</h5>
        <div className="colflex col2">


  <div style={{ position: 'relative' }}
      onBlur={(e) => {
        // Verifica se o foco está saindo do contêiner
        if (!e.currentTarget.contains(e.relatedTarget)) {
          dispatch(clearSugestoesEnderecos()); // Limpa as sugestões
        }
      }}
      tabIndex={-1}  
  >
    <Input
      name="ruaAvenidaRodovia"
      label={nls.configurar?.formRua}
      value={form?.ruaAvenidaRodovia || ''}
      placeholder={nls.configurar?.formRuaPH}
      disabled={(data?.podeSerEditado === 2) ? true : false}
      action={(e, v) => handleChange(e, v)}
      required={{
        erro,
        pattern: formRequired.ruaAvenidaRodovia,
        message: nls.mensagem.obrigatorio,
      }}
    />
    {sugestoes.length > 0 && (
      <ul className="sugestoes-enderecos">
        {sugestoes.map((sugestao, index) => (
          <li
            key={index}
            onClick={() => handleSugestaoClick(sugestao.description, sugestao.place_id)}
          >
            {sugestao.description}
          </li>
        ))}
      </ul>
    )}
  </div>
          <Input
            name='numero'
            type='text'
            label={nls.configurar?.formNumero}
            value={form?.numero || ''} // Certifique-se de que o valor nunca será null/undefined
            //value={form?.numero}
            
            placeholder={nls.configurar?.formNumeroPH}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            action={(e, v) => handleChange(e, v)}
            required={{
              erro,
              pattern: formRequired.numero,
              message: nls.mensagem.obrigatorio
            }}
          />
          <Input
            name='complemento'
            label={nls.configurar?.formComplemento }
            value={form?.complemento}
            //value={form?.number}
            placeholder={nls.configurar?.formComplementoPH}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            action={(e, v) => handleChange(e, v)}
          />
          <Input
            name='bairro'
            label={nls.configurar?.formBairro}
            value={form?.bairro}
            placeholder={nls.configurar?.formBairroPH}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            action={(e, v) => handleChange(e, v)}
          />

          <Input
            name='cidade'
            label={nls.configurar?.formCidade}
            value={form?.cidade}
            placeholder={nls.configurar?.formCidadePH}
            action={(e, v) => handleChange(e, v)}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            required={{
              erro,
              pattern: formRequired.cidade,
              message: nls.mensagem.obrigatorio
            }}
          />
          <Input
            name='estado'
            label={nls.configurar?.formEstado}
            value={form?.estado}
            placeholder={nls.configurar?.formEstadoPH}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            action={(e, v) => handleChange(e, v)}
            required={{
              erro,
              pattern: formRequired.estado,
              message: nls.mensagem.obrigatorio
            }}
          />

          <Input
            name='cep'
            label={nls.configurar?.formCep}
            value={form?.cep}
            placeholder={nls.configurar?.formCepPH}
            action={(e, v) => handleChange(e, v)}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            required={{
              erro,
              pattern: formRequired.cep,
              message: nls.mensagem.obrigatorio
            }}
          />
          <Input
            name='pais'
            label={nls.configurar?.formPais}
            value={form?.pais}
            placeholder={nls.configurar?.formPaisPH}
            action={(e, v) => handleChange(e, v)}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            required={{
              erro,
              pattern: formRequired.pais,
              message: nls.mensagem.obrigatorio
            }}
          />
          {/* <Select
            name='país'
            label={nls.configurar?.formPais}
            options={listas.paises}
            selected={form?.país?form?.país:{}}
            action={(e, v) => handleChange(e, v)}
            textCustom={nls.select}
            optionLabel='name'
            optionValue='id'
            required={{
              erro,
              message: nls.mensagem.obrigatorio
            }}
          /> */}
        </div>
        <div className='colflex col1'>
          <Input
            name='coordenadas'
            label={
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {nls.configurar?.formCordenadas}
                <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray2} />
              </div>
            }
            value={form?.coordenadas}
            placeholder={nls.configurar?.formCordenadasPH}
            disabled={(data?.podeSerEditado === 2) ? true : false}
            action={(e, v) => handleChange(e, v)}
          />
        </div>
        <h5>{nls.configurar?.subTitleRedesSociais}</h5>
        <div>
          <Input
            name='urlTripAdvisorEstabelecimento'
            label={nls.configurar?.formTripAdvisor}
            value={form?.urlTripAdvisorEstabelecimento}                       
            placeholder={nls.configurar?.formTripAdvisorPH}
            action={(e, v) => handleChange(e, v)}
            disabled={(data?.podeSerEditado === 2 && data?.urlTripAdvisorEstabelecimento) ? true : false}         
            right={<>
              <span className='btn-colar' onClick={()=> handleColar('urlTripAdvisorEstabelecimento')}><IcoPaste /> {nls.configurar?.btnColar}</span>
            </>}
          />

          <Input
            name='urlBookingEstabelecimento'
            label={nls.configurar?.formBooking}
            value={form?.urlBookingEstabelecimento}                       
            placeholder={nls.configurar?.formBookingPH}
            action={(e, v) => handleChange(e, v)}
            disabled={(data?.podeSerEditado === 2 && data?.urlBookingEstabelecimento) ? true : false}         
            right={<>
              <span className='btn-colar' onClick={()=> handleColar('urlBookingEstabelecimento')}>
                <IcoPaste /> {nls.configurar?.btnColar}
              </span>
            </>}
          />

        </div>





      </div>
    </Modal>
  )
}